const InstallationList = () =>
  import('../screens/TerminalRegistration/Installation/List/InstallationList.vue');
const TMSRegistrationList = () =>
  import('../screens/TerminalRegistration/TMSRegistration/List/TMSRegistrationList.vue');
const BankRegistrationList = () =>
  import('../screens/TerminalRegistration/BankRegistration/List/BankRegistrationList.vue');

export default [
  {
    component: InstallationList,
    meta: {
      activeSidebarItemId: 'installation',
      authority: 'terminal_installation:view',
      pageTitle: 'Installation',
    },
    name: 'installation',
    path: '/installation',
  },
  {
    component: TMSRegistrationList,
    meta: {
      activeSidebarItemId: 'tms-registration',
      authority: 'tms_registration:view',
      pageTitle: 'TMS Registration',
    },
    name: 'tms-registration',
    path: '/tms-registration',
  },
  {
    component: BankRegistrationList,
    meta: {
      activeSidebarItemId: 'bank-registration',
      authority: 'bank_registration:view',
      pageTitle: 'Bank Registration',
    },
    name: 'bank-registration',
    path: '/bank-registration',
  },
];
